import {Component} from '@angular/core';
import { AppSidebarMinimizerComponent } from './app-sidebar-minimizer/app-sidebar-minimizer.component';
import { AppSidebarHeaderComponent } from './app-sidebar-header/app-sidebar-header.component';
import { AppSidebarFooterComponent } from './app-sidebar-footer/app-sidebar-footer.component';
import { AppSidebarNavComponent } from './app-sidebar-nav/app-sidebar-nav.component';
import { AppSidebarFormComponent } from './app-sidebar-form/app-sidebar-form.component';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    templateUrl: './app-sidebar.component.html',
    imports: [
        AppSidebarMinimizerComponent,
        AppSidebarHeaderComponent,
        AppSidebarFooterComponent,
        AppSidebarNavComponent,
        AppSidebarFormComponent ]
})
export class AppSidebarComponent {
}
